import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { editOrder as editOrderAPI } from 'services/apiOrders';

const useEditOrders = () => {
  
    const queryClient = useQueryClient();
    const{isPending:isEditing, isSuccess:isEdited, mutate: editOrder}=useMutation({
        mutationFn: editOrderAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(['editedOrder'],data)
            console.log("edited order data",data)
            queryClient.invalidateQueries({queryKey:['orderList']})
            queryClient.invalidateQueries({queryKey:['dashStatus']})
            toast.success("Order updated Sucessfully")
        },
        onError:(error)=>{
            console.log("Error occurred while editing orders",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
        }
    })

    return{isEditing, isEdited, editOrder}
}

export default useEditOrders